export default {
  pid: 'Publication Id',
  pids: 'Publication Ids',
  operator: 'Operator',
  user: 'User',
  sacCallId: 'Conversation Id',
  channel: 'Channel',
  field: 'Field',
  operation: 'Operation',
  value: 'Value',
  date: 'Date',
  operators: 'Operators',
  users: 'Users',
  sacCallIds: 'Conversation Ids',
  export: 'Export as XLSX',
  theme: 'Theme',
  polarity: 'Sentiment',
  tag: 'Tag',
  checked: 'Checked',
  status: 'Status',
  replier: 'Operator',
  answered_by: 'Answered by',
  spam: 'Removed',
  oldValue: 'Old Value',
  newValue: 'New Value',
  infoLabel: 'Component Information',
  filterLabel: 'Apply filter',
  trashLabel: 'Clear filter',
  closeLabel: 'Close information',
  statusLabel: 'Status',
  viewPost: 'View publication',
  openChatLabel: 'Open conversation',
  interactionType: 'Interaction type',
  pageName: 'Page',
  pagesName: 'Pages',
  seeConversation: 'View conversation',
  set: 'Set',
  add: 'Add',
  remove: 'Remove',
  gender: 'Gender',
  importeddata: 'Imported data',
  polarityTypes: {
    '3': 'Neutral',
    '2': 'Negative',
    '1': 'Positive',
    '0': 'Without Sentiment',
    '-2': 'Not Classified',
    '-1': 'Negative',
    '': 'Unknown',
  },
  genderTypes: {
    '1': 'Male',
    '2': 'Female',
    '3': 'Organization',
    '0': 'Not Classified',
    '7': 'Organization',
    '': 'Unknown',
  },
  faq: {
    title: 'How to change the Operator?',
    description: 'To change the filter, click on the "Operators" field, select the desired Operators, and click the "filter" icon in the upper right of the table. Only annotations from the selected operators will then be displayed.',
  },
  faq2: {
    title: 'How to filter by Operator and Conversation Id?',
    description: 'To filter by operator and conversation, first select the Operators as in the example above. Then in the "Conversation Ids" field, type the desired Conversation Id (to select more than one, separate multiple Ids by comma). Only annotations from the selected operators in the requested conversation will be displayed.',
  },
  faq3: {
    title: 'How to reset the filter?',
    description: 'To reset the filter, click the "trash" icon below the "filter" icon. This will reset all table filters to default.',
  },
  faq4: {
    title: 'What happens if a publication is deleted?',
    description: 'If a publication is deleted, its annotations will not appear in the table when the filter by conversation id is used.',
  },
  faq5: {
    title: 'How long does it take for the data to load?',
    description: 'There is a delay of 300000 milliseconds (5 minutes) for data insertion into the table.',
  },
  faq6: {
    title: 'How to change the user?',
    description: 'To change the filter, click on the "Users" field, select the desired Users, and click the "filter" icon in the upper right of the table. Only annotations from the selected operators will then be displayed.',
  },
  faq7: {
    title: 'How to filter by user and publication Id?',
    description: 'To filter by user and publication, first select the users as in the example above. Then in the "Conversation Ids" field, type the desired Conversation Id (to select more than one, separate multiple Ids by comma). Only annotations from the selected operators in the requested conversation will be displayed.',
  },
  faq8: {
    title: 'What is the maximum export size?',
    description: 'The component allows exporting up to 90000 rows at a time.',
  },
  question: {
    title: 'What is it?',
    description: 'Percentage of the 12-hour SLA level based on the number of cases answered and closed relative to the total number of cases.',
  },
  question2: {
    title: 'What is it?',
    description: 'Timeless table containing the oldest pending conversations.',
  },
  question3: {
    title: 'What is it?',
    description: 'Chart with status changes made in Smart Care conversations by operator.',
  },
  question4: {
    title: 'What statuses appear in the chart?',
    description: 'Closed, Answered, Ignored',
  },
  annotatedField: 'Annotated field',
  username: 'User name',
  noPostsLabel: 'No publication found',
  details: 'Interaction/Conversation Details',
  group: 'Group',
  interest: 'Interest',
  exportAsPNGLabel: 'Export as PNG',
  noSLAScoreLabel: 'We did not find conversations to measure the SLA with the selected filter',
  sla: 'SLA',
  hour: 'Hour',
  minute: 'Minute',
  smartcareUpdateDate: 'SLA updated',
  smartcareDate: 'Smart Care date',
};
